import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Onboarding } from '@bciti/types';
import { Store } from '@ngrx/store';
import { ToastrService } from 'ngx-toastr';
import { of, Subject } from 'rxjs';
import { catchError, takeUntil, tap } from 'rxjs/operators';
import { BcitiEnvironment } from 'src/app/interfaces/store/store.interface';
import { OnboardingService } from 'src/app/services/onboarding/onboarding.service';
import { State } from 'src/app/store';
import { environmentSelector } from 'src/app/store/global/global.selectors';

@Component({
    selector: 'app-onboarding-edit',
    templateUrl: './onboarding-edit.component.html',
    styleUrls: ['./onboarding-edit.component.scss'],
})
export class OnboardingEditComponent implements OnInit, OnDestroy {
    destroy$ = new Subject();

    env: Partial<BcitiEnvironment>;
    currentOnboarding: Onboarding;
    loading = false;

    constructor(private aRoute: ActivatedRoute, private store: Store<State>, private onboardingService: OnboardingService, private toast: ToastrService) {}

    ngOnInit(): void {
        this.loading = true;
        this.store
            .select(environmentSelector)
            .pipe(
                takeUntil(this.destroy$),
                tap((env) => (this.env = env)),
            )
            .subscribe();

        this.onboardingService
            .getOnboardingById(this.aRoute.snapshot.paramMap.get('id'))
            .pipe(
                takeUntil(this.destroy$),
                tap((onboarding) => (this.currentOnboarding = onboarding)),
                tap(() => (this.loading = false)),
            )
            .subscribe();
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    updateOnboarding(onboarding: Onboarding) {
        this.loading = true;
        this.onboardingService
            .updateOnboarding(onboarding)
            .pipe(
                takeUntil(this.destroy$),
                tap(() => this.toast.success(`Onboarding <b>${onboarding.organisation.tag}</b> was updated`, 'Success', { enableHtml: true })),
                tap(() => (this.loading = false)),
                catchError((error) => {
                    this.toast.error('An error occured. View browser console for details', 'Error');
                    console.error('Update onboarding - error', error);
                    this.loading = false;
                    return of();
                }),
            )
            .subscribe();
    }
}
